import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NavController } from '@ionic/angular';
import { ReturnNativeService } from '../../../shared/service/comunicator-native/return-native/return-native';
import { FormValidations } from '../../../shared/form-validation/form-validation';
import { DefaultPageComponent } from '../../../shared/page/default-page.component';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { AddressService } from '../../services/address.service';
import { AnalycticsNativeService } from '../../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { AnalyticsPageModel } from '../../../shared/model/analyticsPage';
import { AnalyticsPageService } from '../../../shared/service/analytics/analytics-page.service';

@Component({
  selector: 'app-address-name',
  templateUrl: './address-name.page.html',
  styleUrls: ['./address-name.page.scss'],
})
export class AddressNamePageComponent extends DefaultPageComponent implements OnInit {

  public name = '';
  public idComponentName = 'address-name';
  placeholder = '';
  error = false;
  buttonEnable = false;
  textError = '';
  invalidErrorText = 'Nome inválido';
  idLabel = 'page-address-name';
  label = 'nome da rua';
  headerId = 'address-name';
  titlePage = 'Endereço';
  startStage = '';
  endStage = '';
  analyticsPage: AnalyticsPageModel;

  addressNameForm = this.formBuilder.group({
    nameAddress: this.formBuilder.control('', [FormValidations.validationsNameAddress])
  });

  constructor(private formBuilder: FormBuilder,
              public router: NavController,
              public backNativeService: BackNativeService,
              private addressService: AddressService,
              private title: Title,
              public journeyService: JourneyService,
              public returnNativeService: ReturnNativeService,
              public analycticsNativeService: AnalycticsNativeService,
              private analyticsPageService: AnalyticsPageService,
              ) {
              super(backNativeService, journeyService, router, returnNativeService);
              this.getAnalyticsPage();
              this.analyticsData();
              this.getTrack();
              }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.editFieldInvest('rua', 'street', 'address');
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = 'address';

    this.startStage = track.getIndexPage(this.headerId, path).toString();
    this.endStage = track.getTotalPage(path).toString();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.addressName;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  errorMessage() {
    const control = this.addressNameForm.get('nameAddress') as FormControl;
    this.error = control.errors !== null || control.value < 0;

    this.error ? this.buttonEnable = false : this.buttonEnable = true;

    if (control.errors !== null && control.errors.hasOwnProperty('repeated')) {
      this.textError = this.invalidErrorText;
    }
    if (control.errors !== null && control.errors.hasOwnProperty('nameSpace')) {
      this.textError = this.invalidErrorText;
    }
  }

  clickNext() {
    this.addressService.setAddressStreet(this.name);
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = 'Clique';
    const it_complementary = { 
              it_eventaction: this.analyticsPage.action,
              it_eventlabel: this.analyticsPage.back,
              it_pagename: this.analyticsPage.addressName
            };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

  getPageId(): string {
    return this.headerId;
  }
  
  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.address.street) {
      this.name = this.journeyService.registratioJourney.data.address.street;
      this.addressNameForm.controls.nameAddress.setValue(this.journeyService.registratioJourney.data.address.street);
    }
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }
  
  backPage() {
    this.analyticsEventClique();
    this.back();
  }

}
